import { PageHeader, Popconfirm, message, Tooltip, Tag } from "antd";
import React, { Component } from "react";
import axios from 'axios'
import { ButtonItem, SegmentedItem, TableItem, TourItem } from '../../../Components/Items'
import { connect } from "react-redux";
import AgregarActivoFijo from "./AgregarActivoFijo/AgregarActivoFijo";
import { EditOutlined, CheckCircleOutlined, StopOutlined, TagOutlined } from "@ant-design/icons";
import EditarActivoFijo from "./EditarActivoFijo/EditarActivoFijo";
import ModalEtiquetasActivosFijos from "../InventarioActivos/ModalEtiquetasActivosFijos/ModalEtiquetasActivosFijos";

class ActivosFijos extends Component {
  refTabla = React.createRef();
  state = {
    todosActivos: [],
    modalAgregarActivoFijo: false,
    modalEditarActivoFijo: false,
    openTour: false,
    modalEditarActivoFijoId: null,
    modalEtiquetasActivo: false,
    modalEtiquetasActivoId: null,
    loading: false,
    valor: 1,
  }
  componentDidMount() {
    this.consultarActivos(this.state.valor);
  }

  consultarActivos(valor) {
    this.setState({ loading: true })
    axios
      .post(
        "activosFijos/selectActivosFijos",
        { empresaId: this.props.empresaId, valor: valor },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false })
        if (!Array.isArray(res.data)) {
          this.setState({ todosActivos: [] });
        } else {
          this.setState({
            todosActivos: res.data.map(value => {
              return { ...value, accion: { _id: value._id, estado: value.estado } }
            }),
          });
        }
      });
  }
  deshabilitarActivoFijo(value) {
    axios
      .post(
        "activosFijos/deshabilitarActivoFijo",
        { insumoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Activo deshabilitado");
        } else {
          message.error("Sucedió un error y no se pudo deshabilitar");
        }
        this.consultarActivos(this.state.valor);
      });
  }
  habilitarActivoFijo(value) {
    axios
      .post(
        "activosFijos/habilitarActivoFijo",
        { insumoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Activo habilitado");
        } else {
          message.error("Sucedió un error y no se pudo habilitar");
        }
        this.consultarActivos(this.state.valor);
      });
  }
  abrirAgregarActivoFijo() {
    this.setState({ modalAgregarActivoFijo: true });
  }
  cerrarAgregarActivoFijo() {
    this.setState({ modalAgregarActivoFijo: false });
    this.consultarActivos(this.state.valor);
  }
  abrirEditarActivoFijo(id) {
    this.setState({ modalEditarActivoFijo: true, modalEditarActivoFijoId: id });
  }
  cerrarEditarActivoFijo() {
    this.setState({ modalEditarActivoFijo: false });
    this.consultarActivos(this.state.valor);
  }
  abrirEtiquetasActivo(insumoId) {
    this.setState({ modalEtiquetasActivo: true, modalEtiquetasActivoId: insumoId });
  }
  cerrarEtiquetasActivo() {
    this.setState({ modalEtiquetasActivo: false, modalEtiquetasActivoId: null });
  }
  render() {
    const columns = [
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: (a, b) => (a.descripcion < b.descripcion ? -1 : a.descripcion > b.descripcion ? 1 : 0),
      },
      {
        title: "Tipo de Activo",
        dataIndex: "tipoDeActivo",
        key: "tipoDeActivo",
        render: (value) => value?.nombre || "-",
      },
      {
        title: "Unidades Vigentes",
        dataIndex: "unidadesActivas",
        key: "unidadesActivas",
      },
      {
        title: "Estado",
        dataIndex: "estadoActivo",
        key: "estadoActivo",
        render: (value) => value === 2
          ? <Tag color="default" className="square-tag">Baja total</Tag>
          : <Tag color="green" className="square-tag">Con unidades</Tag>,
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        onCell: () => ({ className: "acciones-sin-hover", style: { textAlign: 'center', padding: '4px' } }),
        render: (value, index) => {
          let buttons = [];
          buttons.push(
            <Tooltip key={`etiquetas-${index}`} title="Imprimir etiquetas del inventario" placement="top">
              <ButtonItem
                type="default"
                size="small"
                morado
                icon={<TagOutlined />}
                onClick={() => this.abrirEtiquetasActivo(value._id)}
              />
            </Tooltip>
          );
          if (this.props.permisoEditarActivoFijo) {
            buttons.push(
              <Tooltip key={`editar-${index}`} title="Editar Activo" placement="top">
                <ButtonItem
                  type="default"
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.abrirEditarActivoFijo(value._id)}
                />
              </Tooltip>
            );
          }
          if (this.props.permisoDeshabilitarActivoFijo) {
            if (value.estado === 1) {
              buttons.push(
                <Popconfirm
                  key={`deshabilitar-${index}`}
                  title="Seguro que quieres deshabilitar este Activo"
                  onConfirm={() => this.deshabilitarActivoFijo(value._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tooltip title="Deshabilitar" placement="top">
                    <ButtonItem type="default" size="small" lima icon={<CheckCircleOutlined />} />
                  </Tooltip>
                </Popconfirm>
              );
            } else {
              buttons.push(
                <Popconfirm
                  key={`habilitar-${index}`}
                  title="Seguro que quieres habilitar este Activo"
                  onConfirm={() => this.habilitarActivoFijo(value._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tooltip title="Habilitar" placement="top">
                    <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} />
                  </Tooltip>
                </Popconfirm>
              );
            }
          }
          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ]
    return (
      <>
        <PageHeader
          title="Activos"
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={
            <>
              {window.innerWidth > 1000 &&
                <SegmentedItem
                  options={[{ label: 'Activo', value: 1 }, { label: 'Deshabilitado', value: 2 }, { label: 'Todos', value: 3 }]}
                  onChange={(value) => {
                    this.consultarActivos(value)
                    this.setState({ valor: value })
                  }}
                  value={this.state.valor}
                />
              }
              {this.props.permisoAgregarActivoFijo &&
                <ButtonItem
                  type="primary"
                  key="agregarActivoFijo"
                  onClick={this.abrirAgregarActivoFijo.bind(this)}
                  className="botonAgregar"
                >
                  Agregar Activo
                </ButtonItem>}
              <ButtonItem type="default" blanco onClick={() => this.setState({ openTour: true })}>
                ¿Cómo funciona?
              </ButtonItem>
            </>
          }
        />
        <div ref={this.refTabla}>
          <TableItem
            loading={this.state.loading}
            size='small'
            dataSource={this.state.todosActivos}
            columns={columns}
            onRow={(record) => ({
              onDoubleClick: () => {
                if (this.props.permisoEditarActivoFijo) {
                  this.abrirEditarActivoFijo(record._id)
                }
              },
            })}
          />
        </div>
        <AgregarActivoFijo
          visible={this.state.modalAgregarActivoFijo}
          cerrarAgregarActivoFijo={this.cerrarAgregarActivoFijo.bind(this)}
        />
        <EditarActivoFijo
          visible={this.state.modalEditarActivoFijo}
          id={this.state.modalEditarActivoFijoId}
          cerrarEditarActivoFijo={this.cerrarEditarActivoFijo.bind(this)}
        />
        <ModalEtiquetasActivosFijos
          visible={this.state.modalEtiquetasActivo}
          insumoId={this.state.modalEtiquetasActivoId}
          onCancel={this.cerrarEtiquetasActivo.bind(this)}
        />
        <TourItem
          open={this.state.openTour}
          onClose={() => this.setState({ openTour: false })}
          steps={[
            {
              title: "Activos",
              description: "Un Activo es el 'modelo' de un bien (ej. 'Laptop Dell Latitude'), no la unidad física en sí. Cada Activo pertenece a un Tipo de Activo del que hereda cuentas y reglas de depreciación.",
              target: null,
            },
            {
              title: "Listado",
              description: "Doble clic en una fila para editar. El botón de la etiqueta morada imprime las etiquetas de TODAS las unidades físicas vigentes de ese Activo. Para dar de alta unidades físicas concretas (con su número de serie y fecha de compra), ve a Inventario de Activos.",
              target: () => this.refTabla.current,
            },
          ]}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarActivoFijo: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a69531e49a8383de2bd712c")?.activado,
    permisoEditarActivoFijo: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a69532949a8383de2bd712d")?.activado,
    permisoDeshabilitarActivoFijo: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "6a69533c49a8383de2bd7131")?.activado,
  };
};

export default connect(mapStateToProps)(ActivosFijos);
